// extracted by mini-css-extract-plugin
export default {"tipseenImage":"components-Tipseen-TipseenImage-module__tipseenImage--l8XzI"};